const fieldTypes = {
  master: true,
  intAsString: true,
  epoch: true,
  string: true,
  enum: true,
  boolean: true
}

export const transportationFields = {
  arrivalDate: {
    label: 'Arrival Date',
    apiKey: 'arrivalDate',
    type: fieldTypes,
    rules: [
      {
        test: value => {
          return value !== null && value != '-999' 
        },
        message: 'Field required'
      }
    ],
    errors: [],
    valid: true
  },
  importDate: {
    label: 'Import Date',
    apiKey: 'importDate',
    type: fieldTypes,
    rules: [
      {
        test: value => {
          return value !== null && value != '-999' 
        },
        message: 'Field required'
      }
    ],
    errors: [],
    valid: true
  },
  exportDate: {
    label: 'Export Date',
    apiKey: 'exportDate',
    type: fieldTypes,
    rules: [
      {
        test: value => {
          return value !== null && value != '-999' 
        },
        message: 'Field required'
      }
    ],
    errors: [],
    valid: true
  },
  modeOfTransport: {
    label: 'Mode of Transport',
    apiKey: 'modeOfTransport',
    type: fieldTypes,
    rules: [
      {
        test: value => {
          return value !== ''
        },
        message: 'Field required'
      }
    ],
    errors: [],
    valid: true
  },
  foreignPortOfLadingCode: {
    label: 'Foreign Port of Lading',
    apiKey: 'foreignPortOfLadingCode',
    type: fieldTypes,
    rules: [
      {
        test: value => {
          return value !== ''
        },
        message: 'Field required'
      }
    ],
    errors: [],
    valid: true
  },
  USportOfUnladingCode: {
    label: 'U.S. Port of Unlading',
    apiKey: 'USportOfUnladingCode',
    type: fieldTypes,
    rules: [
      {
        test: value => {
          return value !== ''
        },
        message: 'Field required'
      }
    ],
    errors: [],
    valid: true
  },
  vesselCode: {
    label: 'Vessel Name',
    apiKey: 'vesselCode',
    type: fieldTypes,
    rules: [
      {
        test: value => {
          return value.trim() !== ''
        },
        message: 'Field required'
      }
    ],
    errors: [],
    valid: true
  },
  truckNo: {
    label: 'Mode of Transport',
    apiKey: 'modeOfTransport',
    type: fieldTypes,
    rules: [
      {
        test: value => {
          return true;
        },
        message: 'Field required'
      }
    ],
    errors: [],
    valid: true
  },
  tripInformation: {
    label: 'Voyage',
    apiKey: 'tripInformation',
    type: fieldTypes,
    rules: [
      {
        test: value => {
          return true
        },
        message: 'Field required'
      },
    ],
    errors: [],
    valid: true
  },
  flightNo: {
    label: 'Flight Number',
    apiKey: 'flightNo',
    type: fieldTypes,
    rules: [
      {
        test: value => {
          return value.trim() !== ''
        },
        message: 'Field required'
      },
      {
        test: value => {
          return value.length <= 6
        },
        message: 'Flight length cannot be greater than 6.'
      }
    ],
    errors: [],
    valid: true
  },
  importingCarrier: {
    label: 'IMPORTING CARRIER',
    apiKey: 'importingCarrier',
    type: fieldTypes,
    rules: [{
      test: value => {
        return value.trim() !== ''
      },
      message: 'Field required'
    }],
    errors: [],
    valid: true
  }
}
